const EXTERNAL_URL_PATTERN =
  /^(https?:\/\/|www\.|[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z]{2,})+([/?#]|$))/i;

const normalizeExternalUrl = rawUrl => {
  if (typeof rawUrl !== "string") return "";
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return "";
  return /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
};

export const isExternalRedirect = rawUrl =>
  typeof rawUrl === "string" && EXTERNAL_URL_PATTERN.test(rawUrl.trim());

export const getInternalPathWithoutQuery = rawPath => {
  if (typeof rawPath !== "string") return rawPath;
  return rawPath.split("?")[0];
};

export const appendAuthTokensToUrl = (
  rawUrl,
  { token, lineToken, memberToken } = {}
) => {
  const url = new URL(normalizeExternalUrl(rawUrl));

  if (token && !url.searchParams.has("token")) {
    url.searchParams.set("token", token);
  }
  if (lineToken && !url.searchParams.has("line_token")) {
    url.searchParams.set("line_token", lineToken);
  }
  if (memberToken && !url.searchParams.has("member_token")) {
    url.searchParams.set("member_token", memberToken);
  }

  return url.toString();
};

// หน้าใน flow login/register — ห้ามใช้เป็นปลายทางหลัง login สำเร็จ
// ไม่งั้นผู้ใช้ที่สมัคร/ยืนยันแล้วจะถูกส่งกลับเข้า flow เดิมอีกรอบ
const AUTH_FLOW_PATHS = [
  "/validatetelephone",
  "/confirmotp",
  "/review",
  "/register"
];

const firstQueryValue = value => (Array.isArray(value) ? value[0] : value);

export const isAuthFlowPath = rawPath => {
  if (typeof rawPath !== "string") return false;
  const trimmedPath = getInternalPathWithoutQuery(rawPath.trim())
    .split("#")[0]
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();
  const path = `/${trimmedPath}`;
  return AUTH_FLOW_PATHS.some(
    authPath => path === authPath || path.startsWith(`${authPath}/`)
  );
};

// แปลงค่า query.to / query.redirect เป็นปลายทางที่ใช้ได้
// คืน null ถ้าว่าง หรือเป็นหน้าใน flow login/register
export const resolveRedirectTarget = rawValue => {
  const value = firstQueryValue(rawValue);
  if (typeof value !== "string" || !value.trim()) return null;
  if (isExternalRedirect(value)) return { type: "external", url: value.trim() };
  if (isAuthFlowPath(value)) return null;
  return { type: "internal", path: value.trim() };
};

// สร้าง location ไป /validatetelephone โดยไม่ให้ redirect ชี้กลับหน้าใน flow
// ถ้าอยู่ใน flow อยู่แล้ว ให้คง redirect เดิมของ route ปัจจุบันไว้
export const buildValidateTelephoneLocation = route => {
  const redirect = isAuthFlowPath(route?.path)
    ? firstQueryValue(route?.query?.redirect)
    : route?.path;
  const safeRedirect = isAuthFlowPath(redirect) ? "" : redirect;

  return {
    path: "/validatetelephone",
    query: safeRedirect ? { redirect: safeRedirect } : {}
  };
};
